import { replyTemplatesConstants } from '@constants/reply-templates';

const initialState = {
    data: [],
    loading: true,
    error: '',
    totalCount: 0,
    pages: 1,
};

export function replyTemplates(state = initialState, action) {
    switch (action.type) {
        case replyTemplatesConstants.REPLY_TEMPLATES_REQUEST:
            return { ...state, loading: true, error: '' };
        case replyTemplatesConstants.REPLY_TEMPLATES_SUCCESS:
            return {
                loading: false,
                data: action.data.items,
                totalCount: action.data.totalCount,
                pages: action.data.pages,
                error: '',
            };
        case replyTemplatesConstants.REPLY_ALL_ACTIVE_TEMPLATES_SUCCESS:
            return { ...state, data: action.data };
        case replyTemplatesConstants.REPLY_TEMPLATES_ERROR:
            return { ...state, error: action.message };
        default:
            return state;
    }
}
